import {
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
} from '@angular/forms';

@Component({
  selector: 'dls-left-side-navigation-example',
  templateUrl: './left-side-navigation-example.component.html',
  styleUrls: ['./left-side-navigation-example.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LeftSideNavigationExampleComponent {
  options: FormGroup;

  constructor(fb: FormBuilder) {
    this.options = fb.group({
      bottom: 0,
      fixed: false,
      top: 0
    });
  }
}
